import React, { FunctionComponent } from 'react';
import { Toggle } from 'components/GlobalUI';

interface Props {
  isEnabled: boolean;
  onToggle: (property: string, val: string) => void;
  property: string;
}

export const EnabledToggle: FunctionComponent<Props> = ({
  isEnabled,
  onToggle,
  property,
}) => (
  <div className="input-container input-toggle-switch-container">
    <div className="input-container widget-text-toggle-group">
      <label>
        Enabled
        <Toggle
          value={isEnabled}
          onToggle={(value: string) => onToggle(property, value)}
        />
      </label>
    </div>
  </div>
);
